<template>
  <div style="">
    <NavBar style="background-color: #fff">
      <div slot="title">收款码</div>
    </NavBar>
    <div class="nav-type">
      <div :class="img_type == item.id?'s-text':''" @click="selectId(item.id)"
       class="nav-type-text" v-for="(item,i) in typeList" :key="i">{{item.name}}</div>
    </div>
    <div class="share-img-box">
      <img :src="imgUrl" />
    </div>
    <div class="btn-layout">
      <div class="btn-operation" @click="savePhoto">
        <div class="btn-img-box">
          <img src="@/assets/common/share-save-album.png" alt="" />
        </div>
        <span>保存相册</span>
      </div>
    </div>
  </div>
</template>

<script>
  import NavBar from "@/layout/nav-bar/nav-bar";
  import { getShopPay } from "@/api/shop";

  export default {
    name: "my-code-img",
    components: {
      NavBar,
    },
    data() {
      return {
        typeList:[{name:'普通收款码',id:1},{name:'烟草收款码',id:2},],
        img_type:1,//1普通 2烟草
        imgUrl:'',
      }
    },
    mounted() {
      this.getImg();
    },
    methods:{
      getImg(){
        getShopPay({img_type:this.img_type}).then((res)=>{
          if(res.code == 1){
            this.imgUrl = res.data.pay_img
          }
        })
      },
      selectId(id){
        if(this.img_type != id){
          this.img_type = id;
          this.getImg();
        }
      },
      savePhoto(){
        if (tools.isWx()) {
          Dialog.alert({
            title: "提示",
            message: "长按图片保存到相册~~",
            theme: "round-button",
          }).then(() => {
            // on close
          });
        } else {
          let a = document.createElement("a");
          a.href = this.imgUrl;
          a.click();
        }
      },
    }
  }
</script>

<style scoped lang="less">
    .nav-type{
      box-sizing: border-box;
      padding: 60px 20px 10px 20px;
      background-color: #fff;
      border-top: 2px solid #000;
      display: flex;
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      .nav-type-text{
        font-size: 16px;
        margin-right: 30px;
        color: #333;

      }
      .s-text{
        color: #55aaff !important;
        border-bottom: 2px solid #55aaff;
        font-weight: 600;
      }
    }
    .share-img-box{
      margin: 10px auto 10px auto;
      width: 336px;
      height: 508px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 16px;
      }
    }
    .btn-layout {
      display: flex;
      justify-content: center;
      padding: 10px 58px;
      .btn-operation {
        display: flex;
        flex-direction: column;
        align-items: center;
        .btn-img-box {
          width: 40px;
          height: 40px;
          img {
            display: block;
            width: 100%;
          }
        }
        span {
          margin-top: 6px;
          color: #333;
        }
      }
    }
</style>
